import type { Action, GameConfig, RngState } from '@horde/engine';

const KEY = 'horde:save:v1';

export interface SaveFile {
  config: GameConfig;
  log: Action[];
  botRng: RngState;
  savedAt: number;
}

export function loadSave(): SaveFile | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SaveFile;
    if (!parsed.config || !Array.isArray(parsed.log)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSave(file: SaveFile): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(file));
  } catch {
    // Storage may be unavailable (private mode); the game still plays.
  }
}

export function clearSave(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
